<template>
  <div class="categories-page">
    <div>
<!-- <img src="@/assets/images/logo.jpeg" alt=""> -->
      <h1 class="title">Аш тизмеси</h1>
<!-- <img src="@/assets/images/logo.jpeg" alt=""> -->

    </div>

    <div class="categories-grid">
      <div
        v-for="cat in categories"
        :key="cat.slug"
        class="category-card"
        @click="goToCategory(cat.slug)"
      >
        <div class="bg-image" :style="{ backgroundImage: `url(${cat.image})` }"></div>
        <div class="overlay">
           <h2 class="cat-title">{{ cat.name }}</h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import salats from "@/assets/images/salats.png";
import rolls from "@/assets/images/sushi.jpg";
import pizza from "@/assets/images/pizza.jpg";
import pasta from "@/assets/images/pasta.jpg";
import wok from "@/assets/images/wok.jpeg";
import soups from "@/assets/images/soup.jpeg";
import snacks from "@/assets/images/snacks.jpg";
import sets from "@/assets/images/sets.png";
import milkshake from "@/assets/images/milkshakes.jpg";
import tea from "@/assets/images/tea.jpeg";
import drinks from "@/assets/images/bubble.png";
import sauces from "@/assets/images/souces.png";
import fastfood from "@/assets/images/fastfood.jpg";
import iceCream from '@/assets/images/iceCream.jpg'

export default {
  name: "Categories",

  data() {
    return {
categories: [
  { name: "Роллы", slug: "rolls", image: rolls },
  { name: "Пиццы", slug: "pizza", image: pizza },
  { name: "WOK", slug: "wok", image: wok },
    { name: "Сеты", slug: "sets", image: sets },
  { name: "Снеки", slug: "snacks", image: snacks },
  { name: "Фастфуд", slug: "fastfood", image: fastfood },
  { name: "Мороженое", slug: "icecream", image: iceCream },
  { name: "Соусы", slug: "sauces", image: sauces },
  { name: "Милкшейки", slug: "milkshakes", image: milkshake },
  { name: "Напитки", slug: "drinks", image: drinks },
  { name: "Чаи", slug: "tea", image: tea },
]
    };
  },

  methods: {
    goToCategory(slug) {
      this.$router.push(`/category/${slug}`);
    }
  }
};
</script>

<style scoped>
.categories-page {
  background: #111;
  min-height: 100vh;
  padding: 20px;
  color: #fff;
}

.title {
  text-align: center;
  margin-bottom: 20px;
  font-size: 48px;
  font-weight: 700;
  margin-top: 1rem;
}

/* GRID */
.categories-grid {
  margin-top: 2rem;
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(2, 1fr); /* phones */
}

/* TABLET */
@media (min-width: 600px) {
  .categories-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 18px;
  }
}

/* BIG TABLET */
@media (min-width: 900px) {
  .categories-grid {
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
  }
}

/* DESKTOP */
@media (min-width: 1200px) {
  .categories-grid {
    grid-template-columns: repeat(5, 1fr);
  }
}

.category-card {
  position: relative;
     height: 150px;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: 0.2s;
}
.overlay {
    position: absolute;
    left: 50%;
    bottom: 10px;
    transform: translateX(-50%);
    width: 90%;
    height: 30%;
    background: rgba(0, 0, 0, .8);
    border-radius: 12px;
    display: flex
;
    align-items: center;
    padding-left: 16px;
}
.category-card:hover {
  transform: scale(1.03);
}

@media (min-width: 600px) {
  .category-card {
    height: 170px;
  }
}

@media (min-width: 900px) {
  .category-card {
    height: 200px;
  }
}

.bg-image {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
}



.cat-title {
  position: absolute;
  bottom: 10px;
  left: 12px;
  font-size: 16px;
  font-weight: bold;
}

@media (min-width: 900px) {
  .cat-title {
    font-size: 22px;
  }
}
</style>